import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KursanmeldungApiService, KursanmeldungVO, KursInfoVO } from '@core/api/v1';
import { kursTitelMap } from '@core/model/kursTitel';
import { zertifizierungstyp } from '@core/model/optionen/zertifizierungstyp';
import { NotificationService } from '@core/services/notification/notification.service';
import { dateIsBeforeToday, isSameDay } from '@shared/utils/date-utils';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import TypEnum = KursInfoVO.TypEnum;

@Component({
    selector: 'app-zertifizierungsverlauf',
    standalone: true,
    imports: [TableModule, NgForOf, NgIf, DatePipe, ConfirmDialogModule, DialogModule, RouterLink],
    templateUrl: './zertifizierungsverlauf.component.html',
    styleUrl: './zertifizierungsverlauf.component.scss',
})
export class ZertifizierungsverlaufComponent implements OnInit {
    protected readonly zertifizierungstyp = zertifizierungstyp;
    kursTeilnehmerListe: KursanmeldungVO[] = [];
    visible: boolean = false;
    kursAnmeldung: KursanmeldungVO;

    constructor(
        private kursanmeldungService: KursanmeldungApiService,
        private notificationService: NotificationService,
    ) {}

    ngOnInit(): void {
        this.ladeKurse();
    }

    ladeKurse() {
        this.kursanmeldungService.holeKursTeilnehmerMitTeilnehmer().subscribe((data) => {
            this.kursTeilnehmerListe = data;
        });
    }

    setVisible(kursTeilnehmer: KursanmeldungVO) {
        this.visible = true;
        this.kursAnmeldung = kursTeilnehmer;
    }

    stornieren() {
        this.kursanmeldungService.storniereKursanmeldung(this.kursAnmeldung.id!).subscribe(() => {
            this.notificationService.showSuccess('Anmeldung wurde storniert');
            this.kursAnmeldung.storniert = true;
            this.visible = false;
        });
    }

    istVorgetragen(kurs: KursInfoVO): boolean {
        return dateIsBeforeToday(new Date(kurs.datum!));
    }

    istKursHeute(kurs: KursInfoVO) {
        return isSameDay(new Date(kurs.datum!), new Date());
    }

    titel(typ: TypEnum) {
        return kursTitelMap[typ];
    }

    zertifikatHerunterladen(anmeldung: KursanmeldungVO) {
        this.kursanmeldungService.holeZertifikat(anmeldung.id!, 'response').subscribe((response) => {
            const filename = response.headers.get('X-OEBAK-Filename');
            const blob = new Blob([response.body!], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename!;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }

    getZahlung(kursTeilnehmer: KursanmeldungVO): string {
        if (kursTeilnehmer.zahlungStorniert) {
            return 'storniert';
        } else if (kursTeilnehmer.bezahlt) {
            return 'erhalten';
        }
        return 'offen';
    }

    getAnmeldestatus(kursTeilnehmer: KursanmeldungVO): string {
        if (kursTeilnehmer.widerrufStatus === 'ANGENOMMEN') {
            return 'widerrufen';
        } else if (kursTeilnehmer.storniert) {
            return 'storniert';
        } else if (kursTeilnehmer.teilgenommen) {
            return 'teilgenommen';
        } else if (!this.istVorgetragen(kursTeilnehmer.kurs) || this.istKursHeute(kursTeilnehmer.kurs)) {
            return '';
        } else if (this.istVorgetragen(kursTeilnehmer.kurs) && !kursTeilnehmer.zertifikatVorhanden) {
            return 'Zertifikat noch nicht zugewiesen'
        }
        return 'angemeldet';
    }

    getKursort(kurs: KursInfoVO) {
        if(kurs.online) {
            return 'per Videokonferenz';
        }

        return [kurs.ort, kurs.veranstaltungsort].filter(Boolean).join(', ');
    }
}
